import { defineStore } from 'pinia'
import type { Operator } from '@/data/schema/operator'
import OperatorService from '@/services/operator'

export default defineStore('operators', {
	state: () => ({
		operators: null as Operator[] | null,
		depot: null as string | null
	}),

	getters: {
		hasOperators: (state) => state.operators !== null
	},

	actions: {
		set(depot: string) {
			const api = new OperatorService()

			api.getAllByDepot(depot)
				.then((res) => {
					this.operators = res.data.data
					this.depot = depot
				})
				.catch((error) => {
					console.error(error)
				})
		}
	}
})
